// src/App.jsx
import React, { useEffect, useState, useRef, useCallback } from 'react';

//Style
import style from "./Style/Components/dashboard.module.scss";

//Custom components
import { SplashScreen } from './Components/Other';
import { PrimaryButton, SecondaryButton } from './Components/Buttons';
import { CustomCalendar, CustomDatePicker, CustomSelectBox, CustomTextInput } from "./Components/FormElements";
import CustomFilePicker from './Components/FormElements/file-upload';
import { useLocation, useNavigate } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import SelfPortraitCapture from './Components/Other/capture';
import service from './service';
import { toast, ToastContainer } from 'react-toastify';
import FileService from './api';
import { Modal } from 'bootstrap';
import OpenAccountModal from './Components/Modal/send-mail';
import SuccessConfirmation from './Components/Modal/success-confirmation';
import { subDays } from 'date-fns';
import VerifyDetail from './Components/Modal/verify-detail';


const App = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = useLocation();
    const sigCanvasRef = useRef(null);

    const params = new URLSearchParams(window.location.search);
    const emailValue = params.get("email") || "";
    const mobileNumber = params.get("mobile") || "";
    const countryCode = params.get("country_code") || "";
    const [isSigned, setIsSigned] = useState(false);

    const orgId = params.get("org_id") || "";
    if (emailValue) {
        params.set("email", emailValue);
    }
    if (mobileNumber) {
        params.set("mobile", mobileNumber);
    }
    if (countryCode) {
        params.set("country_code", countryCode);
    }
    // decode back the string
    const queryString = decodeURIComponent(params.toString());

    const navigationUrl = `${location.pathname}?${queryString}`


    const [showSplash, setShowSplash] = useState(true);

    const [flow, setFlow] = useState(0);


    const [residentCardFile, setResidentCardFile] = useState(null);
    const [residentCardFileObject, setResidentCardFileObject] = useState({});
    const [residentCardFileError, setResidentCardFileError] = useState("");

    const [residentCardFileBack, setResidentCardFileBack] = useState(null);
    const [residentCardFileBackObject, setResidentCardFileBackObject] = useState(null);
    const [residentCardFileBackError, setResidentCardFileBackError] = useState("");

    const [cardNumber, setCardNumber] = useState("");
    const [cardNumberError, setCardNumberError] = useState("");

    const [cardExpiryDate, setCardExpiryDate] = useState(null);
    const [cardExpiryDateError, setCardExpiryDateError] = useState("");

    const [capture1, setCapture1] = useState("");
    const [capture1Error, setCapture1Error] = useState("");

    const [capture2, setCapture2] = useState("");
    const [capture2Error, setCapture2Error] = useState("");

    const [passport, setPassport] = useState(null);
    const [passportObject, setPassportObject] = useState(null);
    const [passportError, setPassportError] = useState("");

    const [passportBack, setPassportBack] = useState(null);
    const [passportBackObject, setPassportBackObject] = useState(null);
    const [passportBackError, setPassportBackError] = useState(null);


    const [passportNumber, setPassportNumber] = useState("");
    const [passportNumberError, setPassportNumberError] = useState("");


    const [passportExpiryDate, setPassportExpiryDate] = useState(null);
    const [passportExpiryDateError, setPassportExpiryDateError] = useState("");

    const [name, setName] = useState({ first_name: "", last_name: "" });
    const [nameError, setNameError] = useState({ first_name: "", last_name: "" });

    const [email, setEmail] = useState(emailValue);
    const [emailError, setEmailError] = useState("");

    const [dob, setDob] = useState(null);
    const [dobError, setDobError] = useState("");

    const [selectedGovernorate, setSelectedGovernorate] = useState(null);
    const [selectedGovernorateError, setSelectedGovernorateError] = useState("");

    const [province, setProvince] = useState(null);
    const [provinceError, setProvinceError] = useState("");


    const [selectedCity, setSelectedCity] = useState("");
    const [selectedCityError, setSelectedCityError] = useState("");

    const [selectedArea, setSelectedArea] = useState("");
    const [selectedAreaError, setSelectedAreaError] = useState("");
    const [nationality, setNationality] = useState("");
    const [nationalityError, setNationalityError] = useState("");

    const [address2, setAddress2] = useState("");
    const [address2Error, setAddress2Error] = useState("");

    const [pinCode, setPincode] = useState("");
    const [pinCodeError, setPincodeError] = useState("");

    const [selectedSource, setSelectedSource] = useState(null);
    const [selectedSourceError, setSelectedSourceError] = useState("");

    const [selectedOccupation, setSelectedOccupation] = useState(null);
    const [selectedOccupationError, setSelectedOccupationError] = useState("");

    const [selectedEmployerName, setSelectedEmployerName] = useState("");
    const [selectedEmployerNameError, setSelectedEmployerNameError] = useState("");

    const [captureFile, setCaptureFile] = useState(null);
    // eslint-disable-next-line
    const [captureFileObjectKey, setCaptureFileObjectKey] = useState(null);
    const [captureFileError, setCaptureFileError] = useState("");
    const [recordedVideoURL, setRecordedVideoURL] = useState(null);

    const [fileLoader, setFileLoader] = useState(null);
    const [fileLoader1, setFileLoader1] = useState(null);
    const [fileLoader2, setFileLoader2] = useState(null);
    const [fileLoader3, setFileLoader3] = useState(null);
    const [apiLoader, setApiLoader] = useState(false);

    const [governateList, setGovernateList] = useState([]);
    const [wilayatList, setWilayatList] = useState([]);
    // const [cityList, setCityList] = useState([]);
    // const [areaList, setAreaList] = useState([]);
    const [occupationOptions, setOccupationOptions] = useState([]);
    const [incomeOptions, setIncomeOptions] = useState([]);
    const [signUp, setSignUp] = useState(false);
    const [startCamera, setStartCamera] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [livenessChecked, setLivenessChecked] = useState(false);
    const [livenessError, setLivenessError] = useState("");

    const [livenessOTP, setLivenessOTP] = useState(null);
    const [detailsSubmitted, setDetailsSubmitted] = useState(false);

    const [signError, setSignError] = useState(false);

    const [reviewDetails, setReviewDetails] = useState(null);

    const [isRcMrzFetched, setIsRcMrzFetched] = useState(false);
    const [isPassportMrzFetched, setIsPassportMrzFetched] = useState(false);
    const [paLoader, setPaLoader] = useState(false);
    const [proofOfAddress, setProofOfAddress] = useState(null);


    useEffect(() => {
        if (state !== null) {
            setFlow(state);
        } else {
            setFlow(0);
        }
        console.log("state", state, "flow", flow,);

    }, [state]);

    console.log("governateList", governateList);



    useEffect(() => {
        if (sessionStorage.getItem("step") !== null) {
            setFlow(parseInt(sessionStorage.getItem("step")) + 1);
        }
    }, [sessionStorage.getItem("step")])


    useEffect(() => {
        if (signUp === true) {
            const modal = new Modal(document.getElementById("open-account-modal"));
            modal.show();
        }
    }, [signUp]);

    useEffect(() => {
        if (reviewDetails !== null) {
            const modal = new Modal(document.getElementById("verify-details-modal"));
            modal.show();
        }
    }, [reviewDetails]);


    useEffect(() => {
        if (detailsSubmitted === true) {
            const modal = new Modal(document.getElementById("success-confirmation-modal"));
            modal.show();
        }
    }, [detailsSubmitted]);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });

    }, [flow]);

    useEffect(() => {
        _countryList();
        _generalData();
        _organizationFlag();
    }, []);



    useEffect(() => {
        setCaptureFileError("");
    }, [captureFile]);

    useEffect(() => {
        setResidentCardFileBackError("");
    }, [residentCardFileBack]);

    useEffect(() => {
        setSelectedGovernorateError("");
    }, [selectedGovernorate]);

    useEffect(() => {
        setResidentCardFileError("");
    }, [residentCardFile]);

    useEffect(() => {
        setCardNumberError("");
    }, [cardNumber]);
    useEffect(() => {
        setCardExpiryDateError("");
    }, [cardExpiryDate]);
    useEffect(() => {
        setCapture1Error("");
    }, [capture1]);

    useEffect(() => {
        setCapture2Error("");
    }, [capture2]);

    useEffect(() => {
        setPassportError("");
    }, [passport]);

    useEffect(() => {
        setPassportBackError("");
    }, [passportBack]);

    useEffect(() => {
        setPassportNumberError("");
    }, [passportNumber]);

    useEffect(() => {
        setPassportExpiryDateError("");
    }, [passportExpiryDate]);

    useEffect(() => {
        setEmailError("");
    }, [email]);

    useEffect(() => {
        setDobError("");
    }, [dob]);

    useEffect(() => {
        setProvinceError("");
    }, [province]);

    useEffect(() => {
        setSelectedCityError("");
    }, [selectedCity]);

    useEffect(() => {
        setSelectedAreaError("");
    }, [selectedArea]);

    useEffect(() => {
        setAddress2Error("");
    }, [address2]);

    useEffect(() => {
        setPincodeError("");
    }, [pinCode]);

    useEffect(() => {
        setSelectedSourceError("");
    }, [selectedSource]);

    useEffect(() => {
        setSelectedOccupationError("");
    }, [selectedOccupation]);

    useEffect(() => {
        setSelectedEmployerNameError("");
    }, [selectedEmployerName]);

    const _handleChangeName = (value, field) => {
        setName(prev => ({
            ...prev,
            [field]: value
        }));

        setNameError(prev => ({
            ...prev,
            [field]: ""
        }));
    };

    function _handleClearFields() {
        setResidentCardFileError("");
        setResidentCardFile(null);

        setResidentCardFileBackError("");
        setResidentCardFileBack(null);

        setCardNumberError("");
        setCardNumber("");

        setCardExpiryDateError("");
        setCardExpiryDate(null);

        setCapture1("");
        setCapture1Error("");

        setCapture2("");
        setCapture2Error("");

        setPassport(null);
        setPassportError("");

        setPassportNumber("");
        setPassportNumberError("");

        setPassportExpiryDate(null);
        setPassportExpiryDateError("");

        // setSelectedSource(null);
        setSelectedSourceError("");

        setName({
            first_name: "",
            last_name: ""
        });
        setNameError({
            first_name: "",
            last_name: ""
        });

        // setEmail(emailValue);
        setEmailError("");

        setDob(null);
        setDobError("");

        sigCanvasRef.current?.clear();
        setIsSigned(false);
        setSignError(false);

        setSelectedGovernorate(null);
        setSelectedGovernorateError("");

        setProvince(null);
        setProvinceError("");

        setSelectedCity("");
        setSelectedCityError("");

        setSelectedArea("");
        setSelectedAreaError("");

        setAddress2("");
        setAddress2Error("");

        setPincode("");
        setPincodeError("");

        setSelectedOccupation(null);
        setSelectedOccupationError("");

        setSelectedEmployerName("");
        setSelectedEmployerNameError("");

        setLivenessChecked(false);
        setLivenessError("");

        setRecordedVideoURL(null);
        setStartCamera(false);
        setVideoUrl("");
        setCaptureFileError("");



    }

    console.log("name.first_name", name.first_name);

    const _handleContinue = () => {


        let is_valid = true;

        const validate_email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


        // if (residentCardFile === null) {
        //     setResidentCardFileError("Please upload card details");
        //     is_valid = false;
        // }

        // if (residentCardFileBack === null) {
        //     setResidentCardFileBackError("Please provide card details");
        //     is_valid = false;
        // }

        // if (cardNumber.trim().length === 0) {
        //     setCardNumberError("Please provide card number");
        //     is_valid = false;
        // }

        // if (cardExpiryDate === null) {
        //     setCardExpiryDateError("Please provide expiry date");
        //     is_valid = false;
        // }

        // if (capture1.trim().length === 0) {
        //     setCapture1Error("Please provide capture 1");
        //     is_valid = false;
        // }

        // if (passport === null) {
        //     setPassportError("Please provide passport file");
        //     is_valid = false;
        // }

        // if (residentCardFileBackObject?.json_data?.nationality === "IND" || residentCardFileBackObject?.json_data?.nationality === "PAK") {
        //     if (passportBack === null) {
        //         setPassportBackError("Please provide baskside of passport");
        //         is_valid = false;
        //     }
        // }

        // if (passportNumber.trim().length === 0) {
        //     setPassportNumberError("Please provide passport number");
        //     is_valid = false;
        // }

        // if (passportExpiryDate === null) {
        //     setPassportExpiryDateError("Please provide expiry date");
        //     is_valid = false;
        // }

        if (name.first_name.trim().length === 0) {
            setNameError(prev => ({
                ...prev,
                first_name: "Please provide first name"
            }));
            is_valid = false;
        }

        if (name.last_name.trim().length === 0) {
            setNameError(prev => ({
                ...prev,
                last_name: "Please provide last name"
            }));
            is_valid = false;
        }

        if (nationality === "") {
            setNationalityError("Please provide nationality");
            is_valid = false;
        }

        // if (email.trim().length === 0) {
        //     setEmailError("Please provide email");
        //     is_valid = false;
        // } else if (!validate_email.test(email)) {
        //     setEmailError("Please provide valid email");
        //     is_valid = false;
        // }

        if (dob === null) {
            setDobError("Please provide dob");
            is_valid = false;
        }

        if (sigCanvasRef.current.isEmpty()) {
            setSignError(true);
            is_valid = false;
        }

        if (is_valid === true) {
            // setFlow(2);
            _registerUser();
        }
    };


    // handle save 
    const _handleSave = () => {

        let is_valid = true;

        if (organizationFlags.enable_address === true) {
            if (selectedGovernorate === null) {
                setSelectedGovernorateError("Please Select Country");
                is_valid = false;
            }

            if (province === null) {
                setProvinceError("Please Select State");
                is_valid = false;
            }

            if (selectedCity === "") {
                setSelectedCityError("Please Enter City");
                is_valid = false;
            }

            if (selectedArea === "") {
                setSelectedAreaError("Please Enter Address Line 1");
                is_valid = false;
            }

            if (address2 === "") {
                setAddress2Error("Please Enter Address Line 2");
                is_valid = false;
            }

            if (pinCode === "") {
                setPincodeError("Please Enter Zipcode");
                is_valid = false;
            }

            if (pinCode !== "" && pinCode.length < 6) {
                setPincodeError("Please Enter Valid Zipcode");
                is_valid = false;
            }
        }

        if (organizationFlags.enable_additional_fields === true) {

            if (selectedSource === null) {
                setSelectedSourceError("Please select source of income");
                is_valid = false;
            }

            if (selectedOccupation === null) {
                setSelectedOccupationError("Please select occupation");
                is_valid = false;
            }

            if (selectedEmployerName === "") {
                setSelectedEmployerNameError("Please select employer name");
                is_valid = false;
            }

        }



        if (organizationFlags.enable_liveness === true && livenessChecked === false) {
            setLivenessError("Verify your liveness check");
            is_valid = false;
        }

        if (organizationFlags.enable_video === true) {
            if (recordedVideoURL === null && !startCamera) {
                setCaptureFileError("Please upload a video");
                is_valid = false;
            }
            if (videoUrl === "" && startCamera) {
                setCaptureFileError("Please submit to upload recorded video");
                is_valid = false;
            }
        }

        if (is_valid === true) {
            _addAddress();
        };

    };

    const _handleGetStart = () => {
        // setFlow(1);
        setSignUp(true);
    };

    const _handleCapture = (is_upload, blob) => {
        if (is_upload) {
            setRecordedVideoURL(blob)
            const newFile = new File([blob], "self-portrait.webm", {
                type: 'video/webm',
            });
            _uploadVideo(newFile)
        } else {
            setRecordedVideoURL(blob)
            setCaptureFileError("");
        }
    };

    const _uploadCardDetails = async (file, type) => {

        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

        if (file && file.size > MAX_FILE_SIZE) {
            toast.error("Please upload a file smaller than 5 MB");
            return;
        }

        if (file) {
            if (type === 1) {
                setFileLoader(type);
            } else {
                setFileLoader1(type)
            }
            const url = "user/auth/generate-presigned-url";
            const request = {
                file_name: file.name,
                // user_key: "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjMsImV4cCI6MTc1MTU0MDU0Mn0.lgJ6axYXSGmKbPE2coTCSrwDl-TJAxSnX1C6EnDw-qC-ve1bc_vFbhRZqRCRB9nQLS4qm6tOsYBQr9b7Xo3qqA",
            }
            const response = await service(false, url, request, null)
            if (response.status_code === 200) {
                toast.dismiss()
                let fileResponse = await FileService(response.data.upload_url, file);
                if (type === 1) {
                    setResidentCardFile(file);
                    setResidentCardFileObject({ object_key: response.data.object_key });
                    if (type === 1) {
                        setFileLoader(null)
                    } else {
                        setFileLoader1(null)
                    }
                } else {
                    if (fileResponse?.statusCode === 200) {
                        _sendCardToMRZ(response.data.object_key, file, type)
                    } else {
                        if (type === 1) {
                            setFileLoader(null)
                        } else {
                            setFileLoader1(null)
                        }
                        toast.error("Upload Failed")
                    }
                }
            }
        } else {
            if (type === 1) {
                setResidentCardFile(null);
            } else {
                setResidentCardFileBack(null);
                setCardExpiryDate(null);
                setCardNumber("");
                setCapture1("");
                setCapture2("");
                setDob(null);
                setName({ first_name: "", last_name: "" });
                setResidentCardFileBack(null)
            }
        }
    }

    const _uploadProof = async (file) => {
        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

        if (file && file.size > MAX_FILE_SIZE) {
            toast.error("Please upload a file smaller than 5 MB");
            return;
        }

        if (file) {
            setPaLoader(true);
            const url = "user/auth/generate-presigned-url";
            const request = {
                file_name: file.name,
                // user_key: "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjMsImV4cCI6MTc1MTU0MDU0Mn0.lgJ6axYXSGmKbPE2coTCSrwDl-TJAxSnX1C6EnDw-qC-ve1bc_vFbhRZqRCRB9nQLS4qm6tOsYBQr9b7Xo3qqA",
            }
            const response = await service(false, url, request, null)
            if (response.status_code === 200) {
                toast.dismiss()
                let fileResponse = await FileService(response.data.upload_url, file);
                if (fileResponse?.statusCode === 200) {
                    setProofOfAddress(response.data.view_url);
                    
                } else {
                    toast.error("Upload Failed")
                }
                setPaLoader(false);
            }
        } else {
            setPaLoader(false);
            setProofOfAddress(null);
        }
        
    }

    const _sendCardToMRZ = async (s3Object, file, type) => {
        setPassportBack(null);
        setIsRcMrzFetched(false);
        setPassportBackError("");
        const url = "user/auth/mrz-scan";
        const request = {
            image_id: s3Object,
        }
        const response = await service(false, url, request, null)
        toast.dismiss();
        if (response.status_code === 200) {
            toast.success("File uploaded successfully");
            setCardNumber(response.data.document_number);
            setCapture1(response.data?.optional1);
            setCapture2(response.data?.optional2);
            const [day, month, year] = response.data.expiration_date_readable.split('.');
            const formattedDate = new Date(`${year}-${month}-${day}`);
            setCardExpiryDate(formattedDate);
            const [day1, month1, year1] = response.data.dob_readable.split('.');
            const formattedDate1 = new Date(`${year1}-${month1}-${day1}`);
            setDob(formattedDate1);
            let user_nationality = "";

            if (response.data?.nationality) {       // truthy check covers null, undefined, and ""
                const found = governateList?.find(
                    item => item.value === response.data.nationality
                );
                if (found) user_nationality = found;  // only assign if we actually found a match
            }

            setNationality(user_nationality);
            setNationalityError("");
            // const fullName = response.data.legal_name.trim();
            // const names = fullName.split(" ");

            setName({
                first_name: response.data.first_name, // all but last word
                last_name: response.data.last_name        // last word
            });
            // setReview
            if (type === 1) {
                setFileLoader(null);
            } else {
                setFileLoader1(null);
            }
            setReviewDetails(1);
            setResidentCardFileBack(file);
            setResidentCardFileBackObject({ object_key: s3Object, json_data: response.data });
        } else {
            if (type === 1) {
                setFileLoader(null);
            } else {
                setFileLoader1(null);
            }
            setIsRcMrzFetched(true);
            setResidentCardFileBack(file);
            setResidentCardFileBackObject({ object_key: s3Object, json_data: response.data });
            toast.error(response.message)
            setReviewDetails(1);
        }

    }

    const _uploadPasportDetails = async (file, type) => {
        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

        if (file && file.size > MAX_FILE_SIZE) {
            toast.error("Please upload a file smaller than 5 MB");
            return;
        }
        if (file) {
            if (type === 3) {
                setFileLoader2(type);
            } else {
                setFileLoader3(type);
            }
            const url = "user/auth/generate-presigned-url";
            const request = {
                file_name: file.name,
                // user_key: "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjMsImV4cCI6MTc1MTU0MDU0Mn0.lgJ6axYXSGmKbPE2coTCSrwDl-TJAxSnX1C6EnDw-qC-ve1bc_vFbhRZqRCRB9nQLS4qm6tOsYBQr9b7Xo3qqA",
            }
            const response = await service(false, url, request, null)
            if (response.status_code === 200) {

                toast.dismiss()
                let fileResponse = await FileService(response.data.upload_url, file);
                if (fileResponse?.statusCode === 200) {
                    if (type === 3) {
                        _sendPassportToMRZ(response.data.object_key, file)
                    } else {
                        setPassportBack(file);
                        setPassportBackObject({ object_key: response.data.object_key });
                    }
                } else {
                    if (type === 3) {
                        setFileLoader2(null);
                    } else {
                        setFileLoader3(null);
                    }
                    toast.error("Upload Failed")
                }
            }
        } else {
            if (type === 3) {
                setPassport(null);
                setName({
                    first_name: "",
                    last_name: ""
                });
                setPassportExpiryDate(null);
                setPassportNumber("");
                setDob(null);
                setFileLoader2(null)
            } else {
                setPassportBack(null);
                setFileLoader3(null);
            }
        }
    }

    const _sendPassportToMRZ = async (s3Object, file) => {
        setIsPassportMrzFetched(false);
        const url = "user/auth/mrz-scan";
        const request = {
            image_id: s3Object,
        }
        const response = await service(false, url, request, null)
        toast.dismiss();
        if (response.status_code === 200) {
            toast.success("File uploaded successfully");
            setPassportNumber(response.data.document_number);
            const [day, month, year] = response.data.expiration_date_readable.split('.');
            const formattedDate = new Date(`${year}-${month}-${day}`);
            setPassportExpiryDate(formattedDate);

            const [day1, month1, year1] = response.data.dob_readable.split('.');
            const formattedDate1 = new Date(`${year1}-${month1}-${day1}`);
            setDob(formattedDate1);
            setFileLoader2(null);
            setFileLoader3(null);

            // const fullName = response.data.legal_name.trim();
            // const names = fullName.split(" ");

            setName({
                first_name: response.data.first_name, // all but last word
                last_name: response.data.last_name       // last word
            });
            setReviewDetails(2);

            let user_nationality = "";

            if (response.data?.nationality) {       // truthy check covers null, undefined, and ""
                const found = governateList?.find(
                    item => item.value === response.data.nationality
                );
                if (found) user_nationality = found;  // only assign if we actually found a match
            }

            setNationality(user_nationality);
            setNationalityError("");

            setPassport(file);
            setPassportObject({ object_key: s3Object, json_data: response.data });
        } else {
            toast.error(response.message)
            setFileLoader2(null);
            setFileLoader3(null);
            setIsPassportMrzFetched(true);
            setReviewDetails(2);
            setPassport(file);
            setPassportObject({ object_key: s3Object, json_data: response.data });
        }
    }

    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const _registerUser = async () => {
        setApiLoader(true);
        const url = "user/auth/register";
        let formattedSignData = ""
        if (sigCanvasRef.current && !sigCanvasRef.current.isEmpty()) {
            const dataUrl = sigCanvasRef.current.toDataURL('image/png');
            // Strip the base64 header
            const base64Data = dataUrl.replace(/^data:image\/png;base64,/, '');
            // Append custom suffix (if needed)
            formattedSignData = base64Data;
        }


        const details = JSON.parse(sessionStorage.getItem("details"))

        const request = {
            user_key: sessionStorage.getItem("user_key"),
            "mobile": details.mobile,
            "mobile_number": details.mobile_number,
            "country_code": details.code,
            "fname": name.first_name,
            "lname": name.last_name,
            "email": email,
            "proof_id": null,
            "passport_no": passport !== null ? passportNumber : null,
            "optional1": capture1,
            "optional2": capture2,
            "nationality": nationality?.value,
            "passport_side_1": passport !== null ? passportObject?.object_key : null,
            "passport_side_2": passport !== null ? passportBackObject?.object_key !== undefined ? passportBackObject?.object_key : null : null,
            "address_proof_side_1": residentCardFile !== null ? residentCardFileObject?.object_key !== undefined ? residentCardFileObject?.object_key : null : null,
            "address_proof_side_2": residentCardFileBack !== null ? residentCardFileBackObject?.object_key !== undefined ? residentCardFileBackObject?.object_key : null : null,
            "passport_expiry": passport !== null ? formatDate(passportExpiryDate) : null,
            "address_proof_expiry": residentCardFileBack !== null ? formatDate(cardExpiryDate) : null,
            "cnic_no": cardNumber,
            "sign_data": formattedSignData,
            "dob": formatDate(dob),
            "address_proof_data": residentCardFileBack !== null ? residentCardFileBackObject?.json_data : null,
            "passport_data": passport !== null ? passportObject?.json_data : null
        }
        const response = await service(false, url, request, null)
        toast.dismiss();
        if (response.status_code === 200) {

            if (!organizationFlags.enable_additional_fields &&
                !organizationFlags.enable_address &&
                !organizationFlags.enable_liveness &&
                !organizationFlags.enable_video) {
                _skipAdditional();
            } else {
                setApiLoader(false);
                navigate(navigationUrl, {
                    state: 2
                });
            }


            // sessionStorage.setItem("step", 1)
        } else {
            toast.error(response.message);
            setApiLoader(false);
        }

    }


    const _countryList = () => {
        const url = "user/general/beneficiary-countries";
        service(true, url).then((response) => {
            if (response.status_code === 200) {
                setGovernateList(response.data.map((item) => ({
                    label: item.name,
                    value: item.country_code
                })))
            }
        })
    }

    const _stateList = (selected) => {
        const url = "user/general/country-subdivisions";
        const request = {
            country_code: selected.value
        }
        service(false, url, request).then((response) => {
            if (response.status_code === 200) {
                setWilayatList(response.data.map((item) => ({
                    label: item.name,
                    value: item.id
                })))
            }
        })
    }

    // const _cityList = (selected) => {
    //     const url = "user/general/list-cities";
    //     const request = {
    //         wilayat_id: selected.value
    //     }
    //     service(false, url, request).then((response) => {
    //         if (response.status_code === 200) {
    //             setCityList(response.data.map((item) => ({
    //                 label: item.name,
    //                 value: item.id
    //             })))
    //         }
    //     })
    // }

    // const _areaList = (selected) => {
    //     const url = "user/general/list-areas";
    //     const request = {
    //         city_id: selected.value
    //     }
    //     service(false, url, request).then((response) => {
    //         if (response.status_code === 200) {
    //             setAreaList(response.data.map((item) => ({
    //                 label: item.name,
    //                 value: item.id
    //             })))
    //         }
    //     })
    // }

    const _generalData = () => {
        const url = "user/general/get-data";

        service(true, url).then((response) => {
            if (response.status_code === 200) {
                let source_of_income_data = response.data.filter((item) => item.type_id == 6);
                let source_of_income_data_list = source_of_income_data.map((item) => (
                    {
                        label: item.name,
                        value: item.id
                    }
                ));

                let occupation_data = response.data.filter((item) => item.type_id == 7);
                let occupation_data_list = occupation_data.map((item) => (
                    {
                        label: item.name,
                        value: item.id
                    }
                ))
                setSelectedSource(source_of_income_data_list[0]);
                setOccupationOptions(occupation_data_list);
                setIncomeOptions(source_of_income_data_list);

            }
        })
    }

    const _uploadVideo = async (file) => {
        if (file) {
            const url = "user/auth/generate-presigned-url";
            const request = {
                file_name: file.name,
            }
            const response = await service(false, url, request, null)
            if (response.status_code === 200) {
                toast.dismiss()
                let fileResponse = await FileService(response.data.upload_url, file);
                if (fileResponse?.statusCode === 200) {
                    setVideoUrl(response.data.view_url);
                } else {
                    toast.error("Upload Failed")
                }
            }
        } else {
            setCaptureFile(null);
        }
    }

    const _addAddress = async () => {
        setApiLoader(true);
        const url = "user/auth/add-address";

        const request = {
            user_key: sessionStorage.getItem("user_key"),
            "country_code": selectedGovernorate?.value,
            "state": province?.label,
            "city": selectedCity,
            "address_1": selectedArea,
            "address_2": address2,
            "recent_photograph": captureFileObjectKey,
            "employer_name": selectedEmployerName,
            "source_of_income_id": selectedSource?.value,
            "occupation_id": selectedOccupation?.value,
            "verification_video": videoUrl,
            "zip_code": pinCode,
            "proof_of_address": proofOfAddress
        }
        const response = await service(false, url, request, null)
        toast.dismiss();
        if (response.status_code === 200) {
            setDetailsSubmitted(true);
        } else {
            toast.error(response.message)
        }
        setApiLoader(false);
    }

    const _skipAdditional = async () => {
        setApiLoader(true);
        const url = "user/auth/add-address";

        const request = {
            user_key: sessionStorage.getItem("user_key"),
            "country_code": "",
            "state": "",
            "city": "",
            "address_1": "",
            "address_2": "",
            "recent_photograph": "",
            "employer_name": "",
            "source_of_income_id": null,
            "occupation_id": null,
            "verification_video": "",
            "zip_code": "",
            "proof_of_address": null
        }
        const response = await service(false, url, request, null)
        toast.dismiss();
        if (response.status_code === 200) {
            setDetailsSubmitted(true);
        } else {
            toast.error(response.message)
        }
        setApiLoader(false);
    }

    const _handleOpenLiveness = async () => {
        setLivenessError("");
        let url = window.open("https://livechk.zappit.software/", '_blank', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600');
        if (!url || typeof url.closed == 'undefined') {
            toast.dismiss();
            toast.error("Please enable pop-up permission");
            return false;
        }

        return new Promise((resolve) => {
            const listener = (event) => {
                if (event.data?.type === 'liveness_done') {
                    window.removeEventListener('message', listener);
                    resolve(event.data.payload); // payload = { smileScore, smileImage }
                    console.log('reslieeec', event.data);
                    // setTimeout(() => {
                    url.close()
                    _startLivenessCheck(event.data.payload);
                    // }, 5000);
                }
            };

            window.addEventListener('message', listener);
        });
    }

    const _startLivenessCheck = async (data) => {
        const url = "user/auth/liveness-check"
        const smileImageBuffer = JSON.parse(data.smileImage);
        const request = {
            "user_key": sessionStorage.getItem("user_key"),
            "liveness_data": {
                "smile_data": {
                    "image": smileImageBuffer.data,
                    "confidence": Number(data.smileScore)
                },
            }
        }
        const response = await service(false, url, request, null)
        toast.dismiss();
        if (response.status_code === 200) {
            setLivenessChecked(true);
            setLivenessOTP(response.data.verification_otp);
        } else {
            setLivenessOTP(null);
            toast.error(response.message)
        }


    }


    const [organizationFlags, setOrganizationFlags] = useState({});

    const _organizationFlag = () => {
        const url = "user/auth/organization-flags";
        const request = {
            org_id: orgId
        }
        service(false, url, request).then((response) => {
            if (response.status_code === 200) {
                setOrganizationFlags(response.data);
            } else {
                setOrganizationFlags({});
            }
        })
    };


    useEffect(() => {
        if (signUp === false && detailsSubmitted === false && reviewDetails === null) {
            const handleKeyDown = (e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    if (flow === 1) {
                        _handleContinue();
                    } else if (flow === 2) {
                        _handleSave();
                    }
                }
            };

            window.addEventListener("keydown", handleKeyDown);
            return () => window.removeEventListener("keydown", handleKeyDown);
        }
    }, [signUp, detailsSubmitted, reviewDetails, flow, _handleContinue, _handleSave]);


    return (
        <div className='container'>
            <SplashScreen onFinish={() => setShowSplash(false)} />

            {/* {showSplash ?
                <SplashScreen onFinish={() => setShowSplash(false)} />
                : */}
            <div className=" text-center pb-4 position-relative ">
                {/* <div className='welcome-animation-logo d-flex align-items-center justify-content-center pt-4 mt-2'>
                        <img src={require("./Assets/Images/logo.svg").default}
                            width={200}
                            draggable={false}
                            alt="Tranna logo"
                        />
                    </div> */}

                <div className='welcome-animation text-start'>
                    <div className='row'>

                        {flow === 0 ?
                            <div className='row pt-md-5 pt-2 mt-2'>
                                <div className='offset-lg-2 offset-md-1 col-lg-8 col-md-10'>
                                    <h6 className='mb-2'>
                                        About Z Check
                                    </h6>

                                    <p className='mb-1 pb-1 e-about-z-check'>
                                        At Z Check, we make it simple, fast, and reliable for businesses to screen customers and applicants against global compliance databases. With our advanced platform, you can instantly check individuals and organizations against PEP (Politically Exposed Persons) lists, international sanctions, and adverse media data sources—all in the way that best fits your workflow.
                                    </p>

                                    <p className='mb-3 pb-1 e-about-z-check'>
                                        We understand that compliance is not just a legal requirement but also a cornerstone of trust and reputation. That’s why our solution is built to be flexible, secure, and easy to integrate, ensuring you stay ahead of risks while focusing on growing your business.
                                    </p>

                                    <h6 className='mb-2'>
                                        Checklist
                                    </h6>

                                    <p className='mb-3 pb-1 e-about-z-check'>
                                        This process will take approximately 2–5 minutes to complete.
                                    </p>
                                    <ul className='e-checklist'>
                                        <li>
                                            Personal details (Name, Email, DOB, Signature)
                                        </li>
                                        {
                                            organizationFlags.facematch_enabled === true ?
                                                <>
                                                    <li>
                                                        Resident ID card
                                                    </li>
                                                    <li>
                                                        Passport
                                                    </li>
                                                </>
                                                :
                                                <li>
                                                    Passport or Resident ID card image
                                                </li>
                                        }


                                        {
                                            organizationFlags.enable_video === true ?
                                                <li>
                                                    Video verification
                                                </li>
                                                :
                                                null
                                        }

                                    </ul>

                                    <div className='row pt-sm-4 pt-3 pb-4 '>
                                        <div className='offset-sm-4 offset-1 col-sm-4 col-10'>
                                            <PrimaryButton label="Get Started"
                                                handleClick={_handleGetStart} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            // Form section 
                            <div className='offset-lg-3 offset-md-1 col-lg-6 col-md-10'>
                                <div className='e-form-wrapper mt-4'>

                                    {
                                        !organizationFlags.enable_additional_fields &&
                                            !organizationFlags.enable_address &&
                                            !organizationFlags.enable_liveness &&
                                            !organizationFlags.enable_video ?
                                            null
                                            :
                                            <div className='pb-4'>
                                                <p className={`${style.e_step} mb-2`}>
                                                    {flow} of 2 Steps
                                                </p>
                                                <div className='d-flex gap-1'>
                                                    <div className={style.e_active_step}>
                                                    </div>
                                                    <div className={flow === 1 ? style.e_inactive_step : style.e_active_step}>
                                                    </div>
                                                </div>
                                            </div>
                                    }


                                    {flow === 1 ?
                                        <>
                                            {
                                                organizationFlags.facematch_enabled === false ?
                                                    <div className={`text-start d-flex align-items-start justify-content-start p-3 e-password-info bg-light-blue mb-3 e-font-14 line-height-18px e-primary-font e-font-weight-500 e-text-black mt-3`}>
                                                        <span>
                                                            <svg class="me-1 " width="20" height="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" >
                                                                <path d="M53.25 512.042c0-252.34 206.327-458.667 458.667-458.667s458.669 206.327 458.669 458.667c0 252.342-206.33 458.666-458.669 458.666s-458.667-206.323-458.667-458.666zM511.917 117.375c-216.994 0-394.667 177.674-394.667 394.667 0 216.995 177.673 394.666 394.667 394.666 216.992 0 394.669-177.67 394.669-394.666 0-216.993-177.677-394.667-394.669-394.667z" fill="rgb(29, 46, 153)"></path>
                                                                <path d="M512 309.375c17.673 0 32 14.327 32 32v213.334c0 17.673-14.327 32-32 32s-32-14.327-32-32v-213.334c0-17.673 14.327-32 32-32z" fill="rgb(29, 46, 153)" ></path>
                                                                <path d="M469.078 682.63c0-23.565 19.102-42.669 42.666-42.669h0.383c23.564 0 42.667 19.105 42.667 42.669 0 23.558-19.103 42.662-42.667 42.662h-0.383c-23.564 0-42.666-19.104-42.666-42.662z" fill="rgb(29, 46, 153)" ></path>
                                                            </svg>
                                                        </span>
                                                        <span>Either passport or resident card is mandatory.</span>
                                                    </div>
                                                    : null
                                            }

                                            <div className='pt-1'>
                                                <h4 className='mb-3'>
                                                    Personal Details
                                                </h4>

                                                <div className='d-flex flex-column gap-4'>

                                                    <CustomFilePicker label="Resident card details front"
                                                        required={false}
                                                        value={residentCardFile !== null ? URL.createObjectURL(residentCardFile) : null}
                                                        error={residentCardFileError}
                                                        loading={fileLoader === 1 ? true : false}
                                                        handleChange={(e) => _uploadCardDetails(e, 1)} />

                                                    <CustomFilePicker label="Resident card details back"
                                                        required={false}
                                                        value={residentCardFileBack !== null ? URL.createObjectURL(residentCardFileBack) : null}
                                                        error={residentCardFileBackError}
                                                        loading={fileLoader1 === 2 ? true : false}
                                                        handleChange={(e) => _uploadCardDetails(e, 2)} />

                                                    <CustomTextInput label="Add resident card number"
                                                        type="number"
                                                        value={cardNumber}
                                                        error={cardNumberError}
                                                        // disabled={residentCardFileBack === null ? true : false}
                                                        placeholder="Enter resident card number"
                                                        required={false}
                                                        handleChange={(e) => setCardNumber(e)} />

                                                    {/* <CustomDatePicker label="Add  resident card expiry date"
                                                            required={false}
                                                            value={cardExpiryDate}
                                                            // disabled={residentCardFileBack === null ? true : false}
                                                            error={cardExpiryDateError}
                                                            handleChange={(date) => setCardExpiryDate(date)}
                                                            handleClear={() => setCardExpiryDate(null)} /> */}


                                                    <CustomCalendar label="Add resident card expiry date"
                                                        required={false}
                                                        value={cardExpiryDate}
                                                        error={cardExpiryDateError}
                                                        // minDate={new Date()}
                                                        onClear={() => setCardExpiryDate(null)}
                                                        onSelect={(date) => setCardExpiryDate(date)} />


                                                    {
                                                        capture1 !== "" ?
                                                            <CustomTextInput label="Capture 1"
                                                                type="text"
                                                                value={capture1}
                                                                error={capture1Error}
                                                                // disabled={residentCardFileBack === null ? true : false}
                                                                placeholder="Enter capture 1"
                                                                required={false}
                                                                handleChange={(e) => setCapture1(e)} />
                                                            :
                                                            null
                                                    }

                                                    {
                                                        capture2 !== "" ?
                                                            <CustomTextInput label="Capture 2"
                                                                type="text"
                                                                value={capture2}
                                                                error={capture2Error}
                                                                // disabled={residentCardFileBack === null ? true : false}
                                                                placeholder="Enter capture 2"
                                                                required={false}
                                                                handleChange={(e) => setCapture2(e)} />
                                                            :
                                                            null
                                                    }

                                                </div>
                                            </div>

                                            <div className='pt-4 mt-2'>
                                                <h4 className='mb-3'>
                                                    Passport Details
                                                </h4>
                                                <div className='d-flex flex-column gap-4'>

                                                    <CustomFilePicker label="Upload passport"
                                                        required={false}
                                                        value={passport !== null ? URL.createObjectURL(passport) : null}
                                                        error={passportError}
                                                        loading={fileLoader2 === 3 ? true : false}
                                                        handleChange={(e) => _uploadPasportDetails(e, 3)}
                                                    />


                                                    {
                                                        passportObject !== null &&
                                                            (passportObject?.json_data?.country === "IND" || passportObject?.json_data?.country === "PAK") ? (
                                                            <CustomFilePicker
                                                                label="Upload passport back"
                                                                required={false}
                                                                value={passportBack !== null ? URL.createObjectURL(passportBack) : null}
                                                                error={passportBackError}
                                                                loading={fileLoader3 === 4}
                                                                handleChange={(e) => _uploadPasportDetails(e, 4)}
                                                            />
                                                        ) : null
                                                    }


                                                    <CustomTextInput label="Add passport number"
                                                        type="text"
                                                        placeholder="Enter passport number"
                                                        required={false}
                                                        value={passportNumber}
                                                        // disabled={passport === null ? true : false}
                                                        error={passportNumberError}
                                                        handleChange={(e) => setPassportNumber(e)} />

                                                    {/* <CustomDatePicker label="Add passport expiry date"
                                                            required={false}
                                                            value={passportExpiryDate}
                                                            error={passportExpiryDateError}
                                                            // disabled={passport === null ? true : false}
                                                            handleChange={(date) => setPassportExpiryDate(date)}
                                                            handleClear={() => setPassportExpiryDate(null)} /> */}

                                                    <CustomCalendar label="Add passport expiry date"
                                                        required={false}
                                                        value={passportExpiryDate}
                                                        error={passportExpiryDateError}
                                                        // minDate={new Date()}
                                                        onClear={() => setPassportExpiryDate(null)}
                                                        onSelect={(date) => setPassportExpiryDate(date)} />

                                                    <CustomTextInput label="First name"
                                                        type="text"
                                                        placeholder="Eg: peter"
                                                        required={true}
                                                        value={name.first_name}
                                                        // disabled={passport === null && residentCardFileBack === null ? true : false}
                                                        error={nameError.first_name}
                                                        handleChange={(e) => _handleChangeName(e, "first_name")} />

                                                    <CustomTextInput label="Last name"
                                                        type="text"
                                                        placeholder="Eg: john"
                                                        required={true}
                                                        value={name.last_name}
                                                        // disabled={passport === null && residentCardFileBack === null ? true : false}
                                                        error={nameError.last_name}
                                                        handleChange={(e) => _handleChangeName(e, "last_name")} />
                                                    {/* <CustomTextInput label="Email address"
                                                            type="text"
                                                            placeholder="Eg: example@gmail.com"
                                                            required={true}
                                                            value={email}
                                                            disabled={emailValue ? true : false}
                                                            error={emailError}
                                                            handleChange={(e) => setEmail(e)} /> */}

                                                    {/* <CustomDatePicker label="Date of birth"
                                                            required={true}
                                                            value={dob}
                                                            // disabled={passport === null && residentCardFileBack === null ? true : false}
                                                            error={dobError}
                                                            max={subDays(new Date(), 1)}
                                                            handleChange={(date) => setDob(date)}
                                                            handleClear={() => setDob(null)} /> */}

                                                    <CustomCalendar label="Date of birth"
                                                        required={true}
                                                        value={dob}
                                                        error={dobError}
                                                        maxDate={subDays(new Date(), 1)}
                                                        onClear={() => setDob(null)}
                                                        onSelect={(date) => setDob(date)} />

                                                    <CustomSelectBox label="Nationality"
                                                        placeholder="Select nationality"
                                                        required={true}
                                                        isSearchable={true}
                                                        options={governateList}
                                                        value={nationality}
                                                        error={nationalityError}
                                                        onChange={(value) => {
                                                            setNationality(value);
                                                            setNationalityError("");
                                                        }} />

                                                    {/* <CustomTextArea label="Your signature"
                                                            type="text"
                                                            placeholder="Click to sign"
                                                            required={true}
                                                            value={value}
                                                            handleChange={(e) => setValue(e)} /> */}
                                                    <div className='position-relative'>
                                                        {isSigned && (
                                                            <span
                                                                onClick={() => {
                                                                    sigCanvasRef.current.clear();
                                                                    setIsSigned(false);
                                                                }}
                                                                style={{ position: "absolute", right: 0, top: "30px", zIndex: 10 }}
                                                            >
                                                                <svg
                                                                    className="cursor-pointer position-absolute top-14px right-16px"
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 1024 1024"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path d="M225.83 225.83c16.662-16.662 43.678-16.662 60.34 0l225.83 225.83 225.832-225.83c16.663-16.662 43.674-16.662 60.336 0s16.663 43.678 0 60.34l-225.826 225.83 225.826 225.832c16.663 16.663 16.663 43.674 0 60.336s-43.674 16.663-60.336 0l-225.832-225.826-225.83 225.826c-16.662 16.663-43.678 16.663-60.34 0s-16.662-43.674 0-60.336l225.83-225.832-225.83-225.83c-16.662-16.662-16.662-43.678 0-60.34z" />
                                                                </svg>
                                                            </span>
                                                        )}
                                                        <label className={`e-label pb-2`}>
                                                            Your signature<span className='color-carmine-pink'>*</span>(click to draw)
                                                        </label>

                                                        <SignatureCanvas penColor='#090b0b'
                                                            canvasProps={{ width: 500, height: 120, className: 'sigCanvas p-2' }}
                                                            ref={sigCanvasRef}
                                                            onEnd={() => {
                                                                if (!sigCanvasRef.current.isEmpty()) {
                                                                    setIsSigned(true);
                                                                    setSignError(false);
                                                                }
                                                            }} />
                                                    </div>
                                                </div>

                                                <p className={`mb-4 pb-2 pt-0 ${signError === true ? "e-error-msg" : style.e_note} `}>
                                                    *Please ensure that you draw a valid signature
                                                </p>

                                            </div>

                                            <PrimaryButton label="Save & Continue"
                                                loading={apiLoader}
                                                handleClick={_handleContinue} />
                                        </>
                                        :
                                        // Second step
                                        <>
                                            <div className='pt-1 pb-5'>
                                                <img src={require("./Assets/Images/dropdown.svg").default}
                                                    draggable={false}
                                                    alt='back'
                                                    className='rotate-90 cursor-pointer'
                                                    width={24}
                                                    height={24}
                                                    onClick={() => {
                                                        // setFlow(0);
                                                        navigate(navigationUrl, {
                                                            state: null
                                                        });
                                                    }} />
                                                <h4 className='mb-3 pt-3'>
                                                    Additional Details
                                                </h4>

                                                <div className='d-flex flex-column gap-4'>
                                                    {organizationFlags.enable_address &&
                                                        <>
                                                            <CustomSelectBox label="Country"
                                                                placeholder="Select Country"
                                                                required={true}
                                                                isSearchable={true}
                                                                options={governateList}
                                                                value={selectedGovernorate}
                                                                error={selectedGovernorateError}
                                                                onChange={(value) => {
                                                                    setSelectedGovernorate(value);
                                                                    _stateList(value);
                                                                    setWilayatList([]);
                                                                    setProvince(null);
                                                                }} />

                                                            <CustomSelectBox label="State"
                                                                placeholder="Select State"
                                                                required={true}
                                                                isSearchable={true}
                                                                options={wilayatList}
                                                                value={province}
                                                                error={provinceError}
                                                                isDisabled={selectedGovernorate === null ? true : false}
                                                                onChange={(value) => {
                                                                    setProvince(value);
                                                                }} />

                                                            <CustomTextInput label="City"
                                                                placeholder="City"
                                                                required={true}
                                                                type="text"
                                                                value={selectedCity}
                                                                error={selectedCityError}
                                                                handleChange={(value) => {
                                                                    setSelectedCity(value);
                                                                }} />

                                                            <CustomTextInput label="Address Line 1"
                                                                type="text"
                                                                placeholder="Address Line 1"
                                                                required={true}
                                                                value={selectedArea}
                                                                error={selectedAreaError}
                                                                handleChange={(value) => setSelectedArea(value)} />

                                                            <CustomTextInput label="Address Line 2"
                                                                type="text"
                                                                placeholder="Address Line 2"
                                                                required={true}
                                                                value={address2}
                                                                error={address2Error}
                                                                handleChange={(value) => setAddress2(value)} />

                                                            <CustomTextInput label="Zipcode"
                                                                type="number"
                                                                placeholder="Zipcode"
                                                                required={true}
                                                                value={pinCode}
                                                                error={pinCodeError}
                                                                handleChange={(value) => {
                                                                    if (value.length <= 6) {
                                                                        setPincode(value)
                                                                    }
                                                                }} />

                                                            <CustomFilePicker label="Proof of address"
                                                                required={false}
                                                                value={proofOfAddress}
                                                                loading={paLoader}
                                                                handleChange={(e) => _uploadProof(e, 1)} />
                                                        </>
                                                    }
                                                    {
                                                        organizationFlags.enable_additional_fields &&
                                                        <>
                                                            <CustomSelectBox label="Source of income"
                                                                placeholder="Choose"
                                                                required={true}
                                                                isSearchable={true}
                                                                options={incomeOptions}
                                                                value={selectedSource}
                                                                error={selectedSourceError}
                                                                onChange={(value) => setSelectedSource(value)} />

                                                            <CustomSelectBox label="Occupation"
                                                                placeholder="Choose"
                                                                required={true}
                                                                isSearchable={true}
                                                                options={occupationOptions}
                                                                value={selectedOccupation}
                                                                error={selectedOccupationError}
                                                                onChange={(value) => setSelectedOccupation(value)} />

                                                            <CustomTextInput label="Employer name"
                                                                placeholder="Enter employer name"
                                                                required={true}
                                                                isSearchable={false}
                                                                value={selectedEmployerName}
                                                                error={selectedEmployerNameError}
                                                                handleChange={(value) => setSelectedEmployerName(value)} />
                                                        </>
                                                    }



                                                    {/* <div>
                                                            <label className={`e-label pb-2`}>
                                                                Self portrait*
                                                            </label>
                                                            <div className='e-capture-wrapper p-3'>
                                                                <div className='d-flex gap-2 align-items-center pb-2 '>
                                                                    <img src={require("./Assets/Images/capture.png")}
                                                                        draggable={false}
                                                                        height={18}
                                                                        width={20}
                                                                        alt='capture' />
                                                                    <p className='mb-0 e-title'>
                                                                        Verify with self portrait
                                                                    </p>
                                                                </div>

                                                                <p className='mb-0 e-description'>
                                                                    Confirm your identity with a self captured photograph holding your photo id
                                                                </p>

                                                                <div className='text-center pt-3'>
                                                                    <button className='shadow-none text-center'>
                                                                        Capture now
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div> */}



                                                    {organizationFlags.enable_liveness &&
                                                        <div>
                                                            <label className="e-label pb-2">Liveness check<span className='color-carmine-pink'>*</span></label>
                                                            <div className="e-capture-wrapper p-3">
                                                                {livenessChecked === false && <div className="d-flex gap-2 align-items-center pb-2">
                                                                    <p className="mb-0 e-title">Verify your liveness</p>
                                                                </div>}
                                                                <div>
                                                                    {
                                                                        livenessChecked === false ?
                                                                            <p className="mb-0 e-description">
                                                                                Throw liveness we are restricting the robots
                                                                            </p>
                                                                            :
                                                                            <div className='d-flex justify-content-center'>
                                                                                <p className="mb-0 e-title">
                                                                                    Liveness verified
                                                                                </p>
                                                                                <img src={require('./Assets/Images/success-tick.png')} width={15} height={15} className='ms-2 mt-1' />
                                                                            </div>
                                                                    }

                                                                </div>

                                                                {livenessChecked === false ? <div className="text-center pt-3">
                                                                    <>
                                                                        <div className='d-flex gap-3 justify-content-center'>
                                                                            <div className="text-center">
                                                                                <button onClick={_handleOpenLiveness} className='mt-2'>Start liveness check</button>
                                                                            </div>

                                                                        </div>

                                                                    </>
                                                                </div>
                                                                    :
                                                                    <div className='d-flex gap-3 justify-content-center'>
                                                                        <div className="text-center">
                                                                            <button onClick={_handleOpenLiveness} className='mt-2'>Retry liveness check</button>
                                                                        </div>

                                                                    </div>}
                                                            </div>
                                                            <p className='e-error-msg'>
                                                                {livenessError}
                                                            </p>


                                                        </div>
                                                    }

                                                    {organizationFlags.enable_video &&
                                                        <>
                                                            {
                                                                videoUrl !== "" ?
                                                                    <div className="e-capture-wrapper p-3">
                                                                        <div className="d-flex justify-content-center">
                                                                            <p className="mb-0 mt-0 e-title">Video Recorded</p>

                                                                            <img src={require('./Assets/Images/success-tick.png')} width={15} height={15} className='ms-2 mt-1' />
                                                                        </div>
                                                                        <div className="text-center pt-2">
                                                                            <button onClick={() => {
                                                                                setRecordedVideoURL(null);
                                                                                setVideoUrl("");
                                                                                setCaptureFileError("");
                                                                            }} className='mt-2'>Record again</button>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    recordedVideoURL !== null ?
                                                                        <>
                                                                            <div className="e-capture-wrapper position-relative p-3">
                                                                                <div className="align-items-center text-center">
                                                                                    <p className="mb-0 e-title">Video Recorded</p>
                                                                                    <video
                                                                                        src={recordedVideoURL}
                                                                                        controls
                                                                                        style={{ width: '100%', maxWidth: 450, borderRadius: 8 }}
                                                                                    />

                                                                                    <br />
                                                                                    <div className="text-center pt-4">
                                                                                        <button onClick={() => _handleCapture(true, recordedVideoURL)} className='mt-2 me-3'>Submit</button>
                                                                                        <button onClick={() => {
                                                                                            setRecordedVideoURL(null);
                                                                                            setCaptureFileError("");
                                                                                        }} className='mt-2'>Record again</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <p className='e-error-msg' style={{ marginTop: "-20px" }}>
                                                                                {captureFileError}
                                                                            </p>
                                                                        </>
                                                                        :
                                                                        !startCamera ?
                                                                            <div className='col-12'>

                                                                                <div>
                                                                                    <label className="e-label pb-2">Record video<span className='color-carmine-pink'>*</span></label>
                                                                                    <div className="e-capture-wrapper p-3">
                                                                                        <div className="d-flex gap-2 align-items-center pb-2">
                                                                                            <p className="mb-0 e-title">Record your video</p>

                                                                                        </div>

                                                                                        <div className="text-center pt-3">
                                                                                            <>
                                                                                                <div className='d-flex gap-3 justify-content-center'>
                                                                                                    <div className="text-center">
                                                                                                        <button onClick={() => {
                                                                                                            setStartCamera(true);
                                                                                                            setCaptureFileError("");
                                                                                                        }} className='mt-2'>Video record now</button>
                                                                                                    </div>

                                                                                                </div>

                                                                                            </>
                                                                                        </div>
                                                                                    </div>
                                                                                    <p className='e-error-msg'>
                                                                                        {captureFileError}
                                                                                    </p>


                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            <div>
                                                                                {
                                                                                    livenessOTP !== null ?
                                                                                        <div className='text-center col-12'>
                                                                                            <p className='mb-0'>Read the below OTP while recording the video </p>
                                                                                            <p className='e-label'>{livenessOTP}</p>
                                                                                        </div>
                                                                                        :
                                                                                        null
                                                                                }
                                                                                <SelfPortraitCapture value={captureFile}
                                                                                    error={captureFileError}
                                                                                    handleCapture={(blob) => _handleCapture(false, blob)} />
                                                                            </div>
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                            <PrimaryButton label="Save & Continue"
                                                loading={apiLoader}
                                                handleClick={_handleSave} />
                                        </>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {/* } */}
            <ToastContainer autoClose={6000} />
            {
                signUp === true && <OpenAccountModal
                    handleClose={() => setSignUp(false)}
                    handleConfirm={(step, mail) => {
                        console.log('mail', mail);
                        setEmail(mail);
                        setSignUp(false);
                        navigate(navigationUrl, {
                            state: step + 1
                        });
                        _handleClearFields();

                    }} />
            }
            {
                detailsSubmitted === true && <SuccessConfirmation />
            }
            {
                reviewDetails !== null && <VerifyDetail type={reviewDetails}
                    rcFetched={isRcMrzFetched}
                    passport={isPassportMrzFetched}
                    closeModal={() => { setReviewDetails(null); setIsRcMrzFetched(false); setIsPassportMrzFetched(false) }} />
            }
        </div>
    );
};

export default App;
